import { render, staticRenderFns } from "./wallet-transfer.vue?vue&type=template&id=8013be90"
import script from "./wallet-transfer.vue?vue&type=script&lang=js"
export * from "./wallet-transfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports